import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { Article } from '@interfaces/homepage';
import { User } from '@utils/backend-api/currentUser';

import DealmakerNewsletter from './DealmakerNewsletter';
import ExclusiveCoverage from './ExclusiveCoverage';
import Header from './Header';
import Middle from './Middle';
import OurPartner from './OurPartner';
import WhatWeCover from './WhatWeCover';

export const OFFER_PARAM = 'fn-lp-pro,fn-lp-annual,fn-lp-yp';
export const ANCHOR_LINK_CLASSES =
  'underline hover:text-primary-magenta dark:hover:text-primary-pink focus:text-primary-magenta';

interface FinancialCoverageProps {
  bigReadArticles: Article[];
  env: Env;
  exclusiveArticles: Article[];
  dealMakerNewsletterId: number;
  isCurrentUserLoggedIn: boolean;
  initialCurrentUser?: User;
  isSubscriber: boolean;
  isSubscribedToDealMaker: boolean;
  isWebview: boolean;
}
const queryClient = new QueryClient();
const FinancialCoverage = ({
  bigReadArticles,
  env,
  exclusiveArticles,
  dealMakerNewsletterId,
  isCurrentUserLoggedIn,
  initialCurrentUser,
  isSubscriber,
  isSubscribedToDealMaker,
  isWebview,
}: FinancialCoverageProps) => (
  <QueryClientProvider client={queryClient}>
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <article className="relative mx-auto max-w-[1040px]">
        <div className="!px-16 sm:!px-28 lg:!px-0">
          <Header isSubscriber={isSubscriber} />
          <WhatWeCover />
          <Middle />
          <ExclusiveCoverage
            exclusiveArticles={exclusiveArticles}
            bigReadArticles={bigReadArticles}
          />
          <OurPartner isSubscriber={isSubscriber} />
          <DealmakerNewsletter
            isSubscribedToDealMaker={isSubscribedToDealMaker}
            isCurrentUserLoggedIn={isCurrentUserLoggedIn}
            dealMakerNewsletterId={dealMakerNewsletterId}
          />
        </div>
      </article>
    </AppContextProvider>
  </QueryClientProvider>
);

export default FinancialCoverage;
